module.exports = __webpack_public_path__ + "static/media/insight.84b83140.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/subscription/insight.jpg
// module id = 2923
// module chunks = 0